import { observer } from "mobx-react";
import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { getLocalStorage, LOCAL_STORAGE_TYPE, setLocalStorage } from "../../common/localStorage";
import { LANGUAGE } from "../../common/constants";
import { LanguageIcon } from "../../common/icons";
import { Select } from "antd";

export const Language = observer(({ compact }) => {
  const { t, i18n } = useTranslation();

  const defaultLanguage = useMemo(() => {
    const localLang = getLocalStorage(LOCAL_STORAGE_TYPE.LANGUAGE);
    return Object.values(LANGUAGE).includes(localLang) ? localLang : LANGUAGE.EN;
  }, []);

  const onChangeLanguage = useCallback(
    (language) => {
      setLocalStorage(LOCAL_STORAGE_TYPE.LANGUAGE, language);
      i18n.changeLanguage(language);
      window.AirflexJS.logEvent("change_language", { language });
    },
    [i18n]
  );

  return (
    <div
      className="cursor-pointer flex items-center hover:cursor-default"
      style={{
        gap: compact ? 0 : 8,
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <LanguageIcon />
      <span style={{ display: compact ? "none" : undefined }}>{t("Language")}</span>
      <Select
        className="flex-1 ml-2"
        dropdownStyle={{
          minWidth: 48,
        }}
        size="small"
        defaultValue={defaultLanguage}
        options={[
          { value: LANGUAGE.EN, label: compact ? "En" : "English" },
          { value: LANGUAGE.VI, label: compact ? "Vi" : "Vietnamese" },
        ]}
        onChange={onChangeLanguage}
        showArrow={!compact}
      />
    </div>
  );
});
